export default "__VITE_ASSET__Cc5S6auV__"